import { createRouter, createWebHistory } from 'vue-router';
import {
    hasDataset,
    hasDatasetOrderId,
    welcomePopupBuilder,
    setRecoveryDeepLink
} from '@/router/guards';

import DatasetBuilder from '@/views/builder/DatasetBuilder.vue';
import DatasetCheckout from '@/views/builder/DatasetCheckout.vue';
import DatasetCheckoutFailed from '@/views/builder/DatasetCheckoutFailed.vue';
import DatasetCheckoutSuccess from '@/views/builder/DatasetCheckoutSuccess.vue';
import DatasetConsult from '@/views/builder/DatasetConsult.vue';
import DatasetConsultRequested from '@/views/builder/DatasetConsultRequested.vue';
import DatasetMethod from '@/views/builder/DatasetMethod.vue';
import DatasetSpecification from '@/views/builder/DatasetSpecification.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/dataset-bouwen'
    },
    {
        path: '/dataset-bouwen',
        name: 'builder',
        component: DatasetBuilder,
        beforeEnter: [welcomePopupBuilder, hasDataset]
    },
    {
        path: '/dataset-controleren',
        name: 'specification',
        component: DatasetSpecification,
        beforeEnter: [welcomePopupBuilder, hasDataset]
    },
    {
        path: '/dataset-bestellen',
        name: 'order-method',
        component: DatasetMethod,
        beforeEnter: [hasDataset]
    },
    {
        path: '/dataset-bestellen/afrekenen',
        name: 'order-checkout',
        component: DatasetCheckout,
        beforeEnter: [hasDataset]
    },
    {
        path: '/dataset-bestellen/afrekenen/betaling-afgerond',
        name: 'payment-success',
        component: DatasetCheckoutSuccess,
        beforeEnter: [hasDatasetOrderId],
        props: (route) => ({ order_id: route.query.order_id })
    },
    {
        path: '/dataset-bestellen/afrekenen/betaling-mislukt',
        name: 'payment-failed',
        component: DatasetCheckoutFailed,
        beforeEnter: [hasDatasetOrderId],
        props: (route) => ({ order_id: route.query.order_id })
    },
    {
        path: '/dataset-bestellen/consult',
        name: 'consult',
        component: DatasetConsult,
        beforeEnter: [hasDataset]
    },
    {
        path: '/dataset-bestellen/consult-aangevraagd',
        name: 'consult-requested',
        component: DatasetConsultRequested
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.afterEach((to) => {
  try {
    setRecoveryDeepLink(to, router);
    // eslint-disable-next-line no-empty
} catch {}
});

export default router;
